<script>
  import FileInput from '~componentes/InputFile.vue'

  export default {
    components: { FileInput },
    props: {
      arquivos: {
        type: Array,
        required: true,
      },
      inscricao: {
        type: Object,
        required: true
      },
      labelsLinguagemSelecionada: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        deletados: [],
        arquivosInterno: new Array(1),
      }
    },
    methods: {
      setaQuantidadeArquivos(quantidade) {
        this.arquivosInterno = new Array(quantidade)
      },
      deletar(arquivo) {
        this.arquivos.splice(this.arquivos.indexOf(arquivo), 1);
        this.deletados.push(this.nomeArquivo(arquivo));
      },
      download(arquivo) {
        this.$emit('download', this.nomeArquivo(arquivo));
      },
      nomeArquivo(arquivo) {
        return arquivo.slice(arquivo.lastIndexOf('\\') + 1);
      },
      adicionarArquivo() {
        this.arquivosInterno.push(null);
      },
      limparArquivos() {
        this.deletados = [];

        while (this.arquivosInterno.length != 0) {
          this.arquivosInterno.pop();
        }

        for (var i = 0; i < 1; i++) {
          this.adicionarArquivo();

          if (this.$refs.fileInput[i])
            this.$refs.fileInput[i].removerArquivo();
        }
      },
      existeArquivo() {
        let existeArquivo = false;
        for (let arquivo of this.arquivosInterno) {
          if (arquivo) {
            existeArquivo = true;
            break;
          }
        }
        return existeArquivo;
      },
      emitChanges() {

        let a = []
        for (let arquivo of this.arquivosInterno) {
          if (arquivo) {
            a.push(arquivo.name)
          }
        }
        this.$emit('input', a);
      },
    },
    computed: {},
    mounted() {
      
    },
    created() {
    }
  }
</script>

<template>
  <div>
    <div>
      <span class="font-bold">{{ this.labelsLinguagemSelecionada.labels.arquivosInscricao }}</span>

      <div class="hr-line-dashed margin-top-20"></div>
    </div>

    <div class="alert alert-warning" role="alert" v-show="inscricao.mensagemAnexoArquivos">
      <div class="table-responsive">
        {{this.inscricao.mensagemAnexoArquivos}}
      </div>
    </div>

    <div v-if="arquivos.length > 0">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>{{ this.labelsLinguagemSelecionada.labels.arquivosEnviadosInscricao }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="arquivo in arquivos">
            <td>{{ nomeArquivo(arquivo) }}</td>
            <td class="action">
              <button type="button" class="btn btn-xs btn-success" @click="download(arquivo)">
                <i class="fa fa-download"></i>
              </button>
            </td>
          </tr>
          <tr v-if="arquivos.length === 0">
            <td colspan="2">{{ this.labelsLinguagemSelecionada.labels.nenhumArquivoEncontradoInscricao }}</td>
          </tr>
        </tbody>
      </table>

      <div class="hr-line-dashed margin-top-20"></div>
    </div>

    <div v-if="!this.inscricao.arquivosAprovados">
        <template v-for="(arquivo, indice) in arquivosInterno">
            <file-input v-model="arquivosInterno[indice]" @input="emitChanges()" ref="fileInput"></file-input>
        </template>

        <button type="button" class="btn btn-success" @click="adicionarArquivo">
            <i class="fa fa-plus"></i> {{ this.labelsLinguagemSelecionada.labels.adicionarMaisArquivosInscricao }}
        </button>
    </div>

    <div v-if="!this.inscricao.arquivosAprovados">
      <div class="hr-line-dashed margin-top-20"></div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/compartilhado/AcessosInscricaoArquivos.vue